import React from 'react'
import BladeOpenerModal from './results/bladeopener/BladeOpenerModal';

interface Props{
    errorMessage:string;
}
const ErrorPage = ({errorMessage}:Props) => {
  return (
    
    <div>
    <h3>Wrong apikey</h3>
    <p>
      Welcome! Please note that this site is only accessible for EliteTiming
      customers. If you are experiencing issues accessing the site or any of
      its features, this may be the reason. Ensure that you have the proper
      authorization to access this race.
    </p>
    <p>
      If you are an Elite Timing customer and still experiencing issues,
      please contact our customer service for further assistance. Thank you
      for your understanding and have a pleasant day!
    </p>
    <p>{errorMessage}</p>
  </div>
  )
}

export default ErrorPage